import {
  DescWrapper,
  ErrorCodeBaseWrapper,
  ErrorCodeWrapper,
  ErrorPageBaseWrapper,
  ErrorPageWrapper,
  TitleWrapper,
} from "./Style";

const ErrorPage = ({errorCode}: {errorCode?: number | null}) => {
  return (
    <ErrorPageBaseWrapper className="ErrorPageBaseWrapper">
      <ErrorPageWrapper className="ErrorPage">
        <ErrorCodeBaseWrapper className="ErrorCodeBaseWrapper">
          <ErrorCodeWrapper className="ErrorCodeWrapper">
            <svg
              width="8"
              height="8"
              viewBox="0 0 8 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="4" cy="4" r="3" fill="#106EBE" />
            </svg>
            <span className="txt-error">{errorCode || 400} Error</span>
          </ErrorCodeWrapper>
        </ErrorCodeBaseWrapper>
        <TitleWrapper className="TitleWrapper">
          Invalid app configuration
        </TitleWrapper>
        <DescWrapper className="DescWrapper">
          Please retry and modify your configuration appropriately.
        </DescWrapper>
      </ErrorPageWrapper>
    </ErrorPageBaseWrapper>
  );
};

export default ErrorPage;
